import type { SearchPosition } from '@iheartjane/types';

import type { SidebarSection } from './EditorSidebar';

export const getHighlightedSections = (
  activeSection: SidebarSection | null,
  searchPosition: SearchPosition = 'split'
) => {
  if (!activeSection) return [];

  if (['category_tabs', 'product_cards'].includes(activeSection)) {
    return [activeSection];
  }

  if (activeSection === 'logo') return ['header'];

  if (activeSection === 'search') {
    if (['header', 'filters'].includes(searchPosition)) return searchPosition;

    if (searchPosition === 'split') return ['header', 'filters'];

    if (searchPosition === 'content_header') return ['full_width_search'];
  }

  return [];
};
